import React from 'react'
import { RsIcon } from '../icons'
import { quotePreviewText } from '../../utils/chatQuote'

export function ChatQuoteBlock({
  quote,
  variant = 'bubble',
  self = false,
  onJump,
  onClose,
}) {
  if (!quote) return null

  const preview = quotePreviewText(quote)
  const name = quote.sender_name || 'Member'
  const interactive = variant === 'bubble' && typeof onJump === 'function'

  const body = (
    <>
      <span className="rs-chat-quote-name">{name}</span>
      <span className="rs-chat-quote-text">{preview}</span>
    </>
  )

  if (variant === 'compose') {
    return (
      <div className="rs-chat-quote-compose">
        <div className={`rs-chat-quote-bar ${self ? 'self' : 'them'}`} />
        <div className="rs-chat-quote-body">{body}</div>
        {onClose && (
          <button type="button" className="rs-chat-quote-close" onClick={onClose} aria-label="Cancel quote">
            <RsIcon name="close" size="xs" />
          </button>
        )}
      </div>
    )
  }

  if (interactive) {
    return (
      <button
        type="button"
        className={`rs-chat-quote-bubble ${self ? 'self' : 'them'}`}
        onClick={(e) => {
          e.stopPropagation()
          onJump(quote.id)
        }}
      >
        <span className="rs-chat-quote-bar" aria-hidden />
        <span className="rs-chat-quote-body">{body}</span>
      </button>
    )
  }

  return (
    <div className={`rs-chat-quote-bubble ${self ? 'self' : 'them'}`}>
      <span className="rs-chat-quote-bar" aria-hidden />
      <span className="rs-chat-quote-body">{body}</span>
    </div>
  )
}

export default ChatQuoteBlock
